"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordValidateTokenRequestPayloadToJSON = exports.ForgotPasswordValidateTokenRequestPayloadFromJSONTyped = exports.ForgotPasswordValidateTokenRequestPayloadFromJSON = void 0;
function ForgotPasswordValidateTokenRequestPayloadFromJSON(json) {
    return ForgotPasswordValidateTokenRequestPayloadFromJSONTyped(json, false);
}
exports.ForgotPasswordValidateTokenRequestPayloadFromJSON = ForgotPasswordValidateTokenRequestPayloadFromJSON;
function ForgotPasswordValidateTokenRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'validateLostPasswordToken': json['validateLostPasswordToken'],
    };
}
exports.ForgotPasswordValidateTokenRequestPayloadFromJSONTyped = ForgotPasswordValidateTokenRequestPayloadFromJSONTyped;
function ForgotPasswordValidateTokenRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'validateLostPasswordToken': value.validateLostPasswordToken,
    };
}
exports.ForgotPasswordValidateTokenRequestPayloadToJSON = ForgotPasswordValidateTokenRequestPayloadToJSON;
//# sourceMappingURL=ForgotPasswordValidateTokenRequestPayload.js.map